import { type KeyboardEvent, useEffect, useRef, useState } from 'react';
import IconButton from '~/components/IconButton/IconButton';
import Input from '~/components/ui/Input/Input';
import './RenamingInput.css';

interface RenamingInputProps {
  initialName: string;
  onSave: (newName: string) => void;
  onCancel: () => void;
}

export default function RenamingInput({
  initialName,
  onSave,
  onCancel
}: RenamingInputProps) {
  const [newName, setNewName] = useState(initialName);
  const inputRef = useRef<HTMLInputElement>(null);

  // v-focus equivalent
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  function handleSave() {
    if (newName.trim() !== '') {
      onSave(newName.trim());
    }
  }

  function handleKeydown(e: KeyboardEvent) {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      onCancel();
    }
  }

  return (
    <div className="RenamingInput-root">
      <Input
        ref={inputRef}
        value={newName}
        onChange={setNewName}
        onKeyDown={handleKeydown}
      />
      <IconButton
        disabled={newName === ''}
        icon="check"
        label="Save"
        className="RenamingButton"
        size={16}
        onClick={(e) => {
          e.stopPropagation();
          handleSave();
        }}
      />
      <IconButton
        icon="xmark"
        label="Cancel"
        size={16}
        className="RenamingButton"
        onClick={(e) => {
          e.stopPropagation();
          onCancel();
        }}
      />
    </div>
  );
}
